import { useSelector } from 'react-redux';

// Helper za proveru prava pristupa po modulima (Faza 1 infrastrukture).
// Prava se pune u store iz /users/myPermissions pri loginu (action 'PERMISSIONS').
// Napomena: Faza 1 ne sprovodi enforce nigde — ovo je alat za Fazu 2.
//
// Upotreba:
//   const { can } = usePermission();
//   if (can('FAKTURE', 'edit')) { ... }
//
// level: 'view' (pristup) | 'edit' (azuriranje) | 'delete' (brisanje)

const FIELD = { view: 'pristup', edit: 'azuriranje', delete: 'brisanje' };

export default function usePermission() {
    const permissions = useSelector(s => s.permissions);
    const userRole    = useSelector(s => s.user_role);
    const eskaliran   = useSelector(s => s.eskaliran);

    // Direktor (rola 1) i eskaliran = sve
    const isSuper = !!(eskaliran?.eskaliran) || userRole?.roleId === 1;

    /* Podešavanja pristupa su izuzetak od oba opšta pravila (zadatak 136):

       1. rola Direktor ih NE otvara sama po sebi — pravo se dodeljuje imenom,
          a eskalirani nalog ostaje kao „break-glass" da se niko ne zaključa;
       2. dok prava nisu učitana NE propušta se (fail-closed) — drugde je
          fail-open da stara sesija ne ostane bez ekrana, ali kod prava je
          bolje da stavka na tren fali nego da bljesne onome ko je ne sme.

       Server svejedno proverava isto; ovo je da se i ne prikaže. */
    const JACI_MODUL = 'PRISTUP';

    const can = (moduleKey, level = 'view') => {
        const strogo = moduleKey === JACI_MODUL;
        if (strogo ? !!eskaliran?.eskaliran : isSuper) return true;
        // Prava još nisu učitana (npr. stara sesija pre re-logina) → ne blokiraj (fail-open).
        // Kad su učitana, GET_USER uvek vrati svih 14 modula, pa prazan niz znači stvarno bez prava.
        if (permissions == null) return strogo ? false : true;
        if (!Array.isArray(permissions)) return strogo ? false : true;
        const m = permissions.find(p => p.kljuc === moduleKey);
        if (!m) return false;
        return !!m[FIELD[level] || 'pristup'];
    };

    return { can, isSuper, permissions };
}
